import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'jump-tab-panel',
  styleUrl: 'jump-tab-panel.scss',
  shadow: true,
})
export class JumpTabPanel {

  @Prop() identifier: string = undefined;
  @Prop() active: boolean = false;

  render() {
    return (
      <Host class="JumpTabPanel" id={this.identifier}>
        <div class={"JumpTabPanel__Content " + (this.active ? 'active' : '')}>
          <slot></slot>
        </div>
      </Host>
    );
  }

}
